module.exports = __webpack_public_path__ + "static/media/tracking_widget_icon.a9a8ec63.svg";